import BaseUseCase from "../../base_use_case.js";

class UpdateCurrentUserPaymentMethodUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "put",
      url: `/api/v1/users/payment_methods/current_user`,
      data: this.wrapParams(params, "paymentMethod")
    });
  }
}

const instance = new UpdateCurrentUserPaymentMethodUseCase();
export default instance;